import React, { useEffect, useState } from "react";
import { useServer } from "../hooks/useServer";
import { languageFlags, languages } from "../utils/Helpers";
import { useLiveTutor } from "../hooks/LiveTutorProvider";
import { useTranslation } from "react-i18next";
import { getISO_639_1 } from "language-flag-colors";
import i18n from "../i18nHandler";

// Native Language Selection Component
export const SetNativeLanguage: React.FC = () => {
	const { t } = useTranslation();
	const { user, setUser } = useServer();
	const [nativeLanguage, setNativeLanguage] = useState("");
	const { infoHandlerRef, setShowContinueButton, handleChat } = useLiveTutor();

	useEffect(() => {
		handleChat("Read the question.", false);
	}, []);

	useEffect(() => {
		infoHandlerRef.current = ({
			native_language,
		}: {
			native_language: string;
		}) => {
			setUser({ ...user, native_language: native_language });
			setNativeLanguage(native_language);
		};
	}, []);

	useEffect(() => {
		if (!nativeLanguage) return;
		setShowContinueButton(true);
		const languageCode = getISO_639_1(nativeLanguage);
		i18n.changeLanguage(languageCode || "en");
		setUser({ ...user, native_language: nativeLanguage });
	}, [nativeLanguage]);

	return (
		<div className="flex flex-col items-center justify-center p-6 max-w-md mx-auto w-full h-full mt-28">
			<h3 className="text-2xl font-bold mb-6 text-center">
				{t("native_language")}
			</h3>
			<select
				value={nativeLanguage}
				onChange={(e) => setNativeLanguage(e.target.value)}
				className="w-full p-3 border-2 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all"
			>
				<option value="">{t("select_language")}</option>
				{languages.map((lang) => (
					<option key={lang} value={lang}>
						{languageFlags[lang]} {lang}
					</option>
				))}
			</select>
		</div>
	);
};

// English Level Component
export const SetEnglishLevel: React.FC = () => {
	const { t } = useTranslation();
	const { handleChat } = useLiveTutor();

	useEffect(() => {
		handleChat("Read the question.", false);
	}, []);

	return (
		<div className="flex flex-col items-center justify-center p-6 max-w-md mx-auto w-full h-full mt-28">
			<h2 className="text-2xl mb-6 text-center">{t("english_level")}</h2>
			<p className="text-sm text-center text-gray-600">
				Tell me about your experience with English.
			</p>
		</div>
	);
};

// Learning Goals Component
export const SetGoals: React.FC = () => {
	const { t } = useTranslation();
	const { handleChat } = useLiveTutor();

	useEffect(() => {
		handleChat("Read the question.", false);
	}, []);

	return (
		<div className="flex flex-col items-center justify-center p-6 max-w-md mx-auto w-full h-full mt-28">
			<h2 className="text-2xl mb-6 text-center">{t("learning_goals")}</h2>
			<p className="text-sm text-center text-gray-600">
				Tell me about what you want to improve.
			</p>
		</div>
	);
};

// Interests Component
export const SetInterests: React.FC = () => {
	const { t } = useTranslation();
	const { handleChat } = useLiveTutor();

	useEffect(() => {
		handleChat("Read the question.", false);
	}, []);

	return (
		<div className="flex flex-col items-center justify-center p-6 max-w-md mx-auto w-full h-full mt-28">
			<h2 className="text-2xl mb-6 text-center">{t("interests")}</h2>
			<p className="text-sm text-center text-gray-600">
				Tell me about your interests.
			</p>
		</div>
	);
};
